import { useContextState } from "../../../../../../../../../../hooks/theme";

export const useStyles = () => {
    const { colors } = useContextState()

    return {
        bulb: {
            '& svg': {
                width: 32,
                height: 32,
            },
        },
        add: (notColor: boolean) => ({
            fontSize: '2rem',
            color: notColor ? colors.color32 : colors.color1,
            padding: '6px',
            '& .MuiSvgIcon-root': {
                fontSize: '1em',
            },
        }),
        dFlex: {
            display: 'flex',
            gap: 1,
            alignItems: 'center'
        },
        containerHeader: {
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'space-between'
        },
        title: {
            color: colors.color1,
            fontWeight: 'bold'
        },
        paperC: {
            padding: 3,
            backgroundColor: '#FAFAFA'
        }
    }
}

